<template>
  <v-card v-if="tabs.length > 0">
    <Tabs v-model="tabSelection">
      <v-tab
        class="activeTab"
        v-for="(name, index) in formattedTabs"
        :key="`${name}${index}`"
        @click="handleTabClick(index)"
      >
        {{ name }}
      </v-tab>
    </Tabs>
  </v-card>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      default: function() { return [] }
    },
    lvl: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      tabSelection: 0
    };
  },
  computed: {
    formattedTabs() {
      return this.tabs.map(tabName => {
        const name = typeof tabName === 'object' ? tabName.name : tabName;
        return this.$t(name === 'scb' ? 'smb' : name).toUpperCase();
      });
    }
  },
  methods: {
    handleTabClick(tabIndex) {
      this.$emit('activeTabChange', { tab: tabIndex, level: this.lvl });
    }
  },
  watch: {
    tabs: {
      immediate: true,
      handler() {
        this.tabSelection = 0;
      }
    }
  }
};
</script>

<style scoped>
.activeTab:hover {
  background-color: var(--v-sixth-base);
}
</style>
